import React, { useState, useEffect } from "react";
import Modal from "../components/Modal";
import {
  getBrands,
  createBrand,
  updateBrand,
  deleteBrand,
} from "../../firebase/firestoreService";

const emptyForm = () => ({ name: "", tagBg: "#1a1a1a", tagColor: "#ffffff" });

export default function BrandsSection() {
  const [brands,    setBrands]    = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing,   setEditing]   = useState(null);
  const [form,      setForm]      = useState(emptyForm());
  const [saving,    setSaving]    = useState(false);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    setBrands(await getBrands());
    setLoading(false);
  };

  const openAdd  = () => { setEditing(null); setForm(emptyForm()); setModalOpen(true); };
  const openEdit = (b) => { setEditing(b); setForm({ name: b.name, tagBg: b.tagBg, tagColor: b.tagColor }); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setEditing(null); };
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.name.trim()) { alert("Brand name is required."); return; }
    setSaving(true);
    if (editing) {
      await updateBrand(editing.id, form);
    } else {
      await createBrand(form);
    }
    await fetchAll();
    setSaving(false);
    closeModal();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this brand? Products linked to it will lose their brand tag.")) return;
    await deleteBrand(id);
    setBrands((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <div>
      <div className="dash-main__header">
        <h2 className="dash-main__title">Brands</h2>
        <button className="btn-primary" onClick={openAdd}>+ Add Brand</button>
      </div>

      {loading ? (
        <p className="dash-empty">Loading…</p>
      ) : brands.length === 0 ? (
        <p className="dash-empty">No brands yet.</p>
      ) : (
        <div className="dash-table-wrap">
          <table className="dash-table">
            <thead>
              <tr>
                <th>Brand Name</th>
                <th>Tag Preview</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {brands.map((b) => (
                <tr key={b.id}>
                  <td><strong>{b.name}</strong></td>
                  <td>
                    <span
                      style={{
                        background: b.tagBg,
                        color: b.tagColor,
                        padding: "3px 10px",
                        borderRadius: 20,
                        fontSize: 10,
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                      }}
                    >
                      {b.name}
                    </span>
                  </td>
                  <td>
                    <button className="btn-edit" onClick={() => openEdit(b)}>Edit</button>
                    <button className="btn-danger" onClick={() => handleDelete(b.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modalOpen && (
        <Modal title={editing ? "Edit Brand" : "Add Brand"} onClose={closeModal}>
          <div className="form-group">
            <label className="form-label">Brand Name *</label>
            <input
              className="form-input"
              value={form.name}
              onChange={(e) => setField("name", e.target.value)}
              placeholder="e.g. Good Vibes"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Tag Background</label>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <input
                  type="color"
                  value={form.tagBg}
                  onChange={(e) => setField("tagBg", e.target.value)}
                  style={{ width: 40, height: 36, border: "none", cursor: "pointer", borderRadius: 6 }}
                />
                <input
                  className="form-input"
                  value={form.tagBg}
                  onChange={(e) => setField("tagBg", e.target.value)}
                  placeholder="#1a1a1a"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Tag Text Color</label>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <input
                  type="color"
                  value={form.tagColor}
                  onChange={(e) => setField("tagColor", e.target.value)}
                  style={{ width: 40, height: 36, border: "none", cursor: "pointer", borderRadius: 6 }}
                />
                <input
                  className="form-input"
                  value={form.tagColor}
                  onChange={(e) => setField("tagColor", e.target.value)}
                  placeholder="#ffffff"
                />
              </div>
            </div>
          </div>

          {/* Live preview */}
          <div className="form-group">
            <label className="form-label">Preview</label>
            <span
              style={{
                background: form.tagBg,
                color: form.tagColor,
                padding: "4px 12px",
                borderRadius: 20,
                fontSize: 11,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
              }}
            >
              {form.name || "Brand Name"}
            </span>
          </div>

          <div className="form-actions">
            <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            <button className="btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? "Saving…" : editing ? "Save Changes" : "Add Brand"}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
